import { classNames } from '@dimjs/utils';
import { flatbizDate, TNoopDefine } from '@flatbiz/utils';
import { CSSProperties, FC, Fragment, useMemo } from 'react';
import { useCountdown } from '../hooks/use-count-down';

/**
 * 倒计时
 * ```
 * 1. seconds 倒计时秒数
 * 2. 默认分隔符 x天x时x分x秒
 * ```
 */
export type CountDownProps = {
  className?: string;
  style?: CSSProperties;
  // 倒计时秒数
  seconds: number;
  // 分割符
  split?: {
    d?: string;
    h?: string;
    m?: string;
    s?: string;
  };
  onEnd?: TNoopDefine;
};
export const CountDown: FC<CountDownProps> = (props) => {
  const targetDate = useMemo(() => {
    return flatbizDate.update(new Date(), 's', props.seconds || 0);
  }, [props.seconds]);

  const { days, hours, minutes, seconds } = useCountdown({
    targetDate,
    onEnd: props.onEnd,
  });

  const timeArray = useMemo(() => {
    const _timeArray = [] as { type: string; value: string }[];
    if (days > 0) {
      _timeArray.push({
        type: 'd',
        value: String(days),
      });
    }
    if (hours >= 0) {
      if (hours > 0 || days > 0) {
        _timeArray.push({
          type: 'h',
          value: String(hours),
        });
      }
    }
    _timeArray.push({
      type: 'm',
      value: minutes < 10 ? `0${minutes}` : String(minutes),
    });
    _timeArray.push({
      type: 's',
      value: seconds < 10 ? `0${seconds}` : String(seconds),
    });

    return _timeArray;
  }, [days, hours, minutes, seconds]);

  return (
    <span className={classNames('v-count-down', props.className)} style={props.style}>
      {timeArray.map((item, index) => {
        return (
          <Fragment key={index}>
            <span className="v-count-down-value">{item.value}</span>
            <span className="v-count-down-sign">{props.split?.[item.type]}</span>
          </Fragment>
        );
      })}
    </span>
  );
};

CountDown.defaultProps = {
  split: {
    d: '天',
    h: '时',
    m: '分',
    s: '秒',
  },
};
